// Okta Service for Bedrock Chat App
// Works with Lambda authorizer for authentication

import tokenRefreshService from './tokenRefreshService';
import logger from '../utils/logger';

class OktaService {
  constructor() {
    this.oktaAuth = null;
    this.apiGatewayUrl = process.env.REACT_APP_API_GATEWAY_URL;
  }

  // Initialize with Okta Auth instance
  initialize(oktaAuth) {
    this.oktaAuth = oktaAuth;

    // Start automatic token refresh
    tokenRefreshService.startAutoRefresh(oktaAuth);

    logger.info('[OKTA-SERVICE] Initialized with automatic token refresh');
  }

  // Check if user is authenticated
  isAuthenticated() {
    return this.oktaAuth && this.oktaAuth.isAuthenticated();
  }

  // Get user info
  async getUserInfo() {
    if (!this.oktaAuth) return null;

    try {
      const user = await this.oktaAuth.getUser();
      return user;
    } catch (error) {
      logger.error('[OKTA-SERVICE] Error getting user info:', error);
      return null;
    }
  }

  // Get ID token (preferred for authentication)
  async getIdToken() {
    if (!this.oktaAuth) return null;

    try {
      const idToken = await this.oktaAuth.getIdToken();
      return idToken;
    } catch (error) {
      logger.error('[OKTA-SERVICE] Error getting ID token:', error);
      return null;
    }
  }

  // Get access token
  async getAccessToken() {
    if (!this.oktaAuth) return null;

    try {
      // Try ID token first (has user info), fallback to access token
      const idToken = await this.getIdToken();
      if (idToken) return idToken;

      const accessToken = await this.oktaAuth.getAccessToken();
      return accessToken;
    } catch (error) {
      logger.error('[OKTA-SERVICE] Error getting access token:', error);
      return null;
    }
  }

  // Sign out
  async signOut() {
    if (!this.oktaAuth) return;

    try {
      // Stop token refresh before signing out to prevent memory leak
      tokenRefreshService.stopAutoRefresh();
      await this.oktaAuth.signOut();
    } catch (error) {
      logger.error('[OKTA-SERVICE] Error signing out:', error);
    }
  }
}

export default new OktaService();
